"use client";

import { useState, useEffect } from "react";
import { Inter } from "next/font/google";
import classNames from "classnames";
import { useWiggleAnimation } from "@/hooks/useWiggleAnimation";
import { Spinner } from "./Spinner";

const inter = Inter({ subsets: ["latin"] });


export const PorangeButton = ({
	children = "",
	full = false,
	animate = false,
	variation = "default",
	showLoader = false,
	disabled = false,
	className,
	onClick,
	id,
	error = false,
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const { isWiggling } = useWiggleAnimation(animate);

	useEffect(() => {
		if (error) {
			setIsLoading(false);
		}
	}, [error]);

	if (!children) {
		throw new Error("Button text is required");
	}

	return (
		<div
			id={id}
			onClick={(event) => {
				if (variation === "tt-slider-quiz-question" || showLoader) {
					setIsLoading(true);
				}

				onClick(event);
			}}
			className={classNames(inter.className, className, {
				"animate-wiggle": isWiggling,
				"h-[60px] rounded-[20px] text-lg": variation === "large",
				"text-base p-4 flex items-center justify-center gap-2 text-white font-bold px-3 py-2": true,
				"bg-gradient-dark-porange hover:bg-gradient-darker-porange active:bg-gradient-darker-porange":
					["default", "large"].includes(variation),
				"h-12 rounded-xl": variation === "default",
				"h-20 rounded-full bg-gradient-tt-slider-quiz-question shadow-md":
					variation === "tt-slider-quiz-question",
				"user-select-none cursor-pointer": !disabled,
				"w-full": full,
				"w-80 max-w-full": !full,
				"opacity-50 cursor-not-allowed pointer-events-none": disabled,
			})}>
			{isLoading && showLoader ? <Spinner /> : children}
		</div>
	);
};
